(function () {
  "use strict";
  var root = document.querySelector('[data-mh-demo]');
  if (!root || root.dataset.mhReady) return;
  root.dataset.mhReady = '1';

  // Strings come from Liquid so the demo speaks the visitor's language.
  // Every lookup falls back to English, so a missing key degrades to readable
  // rather than to "undefined".
  var T = window.MH_DEMO_I18N || {};
  function t(k, d) { return T[k] || d; }

  var lid = root.querySelector('#mhLid'),
      lidMove = root.querySelector('#mhLidMove'),
      drawer = root.querySelector('#mhDrawer'),
      drawerMove = root.querySelector('#mhDrawerMove'),
      bag = root.querySelector('#mhBag'),
      pellets = root.querySelector('#mhPellets'),
      seal = root.querySelector('#mhSeal'),
      btnLid = root.querySelector('#mhBtnLid'),
      btnDrop = root.querySelector('#mhBtnDrop'),
      btnDrawer = root.querySelector('#mhBtnDrawer'),
      status = root.querySelector('#mhStatus');

  var lidOpen = false, drawerOpen = false, dropping = false;

  function say(html) { status.innerHTML = html; }

  function renderLid() {
    lidMove.style.transform = lidOpen ? 'rotate(-104deg)' : 'rotate(0deg)';
    lid.setAttribute('aria-expanded', String(lidOpen));
    btnLid.setAttribute('aria-pressed', String(lidOpen));
    btnLid.textContent = lidOpen ? t('lidClose', 'Close the lid') : t('lidOpen', 'Open the lid');
    bag.style.opacity = lidOpen ? '1' : '0';
    if (lidOpen) {
      seal.style.opacity = '0';
      say(t('stateOpen', 'Open. That is <b>a normal bin bag</b> in there &mdash; the one you already buy.'));
    } else {
      seal.style.opacity = '1';
      say(t('stateSealed', 'Closed and <b>sealed</b>. The smell stays in the bag, not in the room.'));
    }
  }

  function renderDrawer() {
    drawerMove.style.transform = drawerOpen ? 'translateY(34px)' : 'translateY(0)';
    drawer.setAttribute('aria-expanded', String(drawerOpen));
    btnDrawer.setAttribute('aria-pressed', String(drawerOpen));
    btnDrawer.textContent = drawerOpen ? t('drawerClose', 'Close the drawer') : t('drawerOpen', 'Open the drawer');
    if (drawerOpen) say(t('stateDrawer', 'Bin day: pull the drawer, <b>lift the bag out</b>, tie it, done.'));
  }

  function toggleLid() { lidOpen = !lidOpen; renderLid(); }
  function toggleDrawer() { drawerOpen = !drawerOpen; renderDrawer(); }

  function drop() {
    if (dropping) return;
    dropping = true;
    if (!lidOpen) { lidOpen = true; renderLid(); }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    pellets.style.transform = 'translateY(0)';
    pellets.style.opacity = '1';
    var fall = function () {
      pellets.style.transform = 'translateY(250px)';
      var settle = function () {
        pellets.style.opacity = '0';
        pellets.style.transform = 'translateY(0)';
        lidOpen = false; renderLid();
        dropping = false;
      };
      reduce ? settle() : setTimeout(settle, 620);
    };
    reduce ? fall() : setTimeout(fall, 60);
  }

  lid.addEventListener('click', toggleLid);
  drawer.addEventListener('click', toggleDrawer);
  btnLid.addEventListener('click', toggleLid);
  btnDrawer.addEventListener('click', toggleDrawer);
  btnDrop.addEventListener('click', drop);

  [[lid, toggleLid], [drawer, toggleDrawer]].forEach(function (pair) {
    pair[0].addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pair[1](); }
    });
  });

  renderLid();
  renderDrawer();
  say(t('stateIdle', 'Tap the lid. Inside there is <b>an ordinary bin bag</b> &mdash; no cassette.'));
})();
